export default "__VITE_ASSET__BOfcJh6V__"